/* eslint-disable @typescript-eslint/no-explicit-any */
// src/redux/workflows/notifications/thunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NotificationsListResponse, FetchNotificationsPayload } from './types';
import { apiClient } from '@/utils/apiClient';
import { toQS } from '@/utils/toQS';

export const fetchNotifications = createAsyncThunk<
  NotificationsListResponse,
  FetchNotificationsPayload | undefined,
  { rejectValue: string }
>('workflows/notifications/fetch', async (payload, { rejectWithValue }) => {
  try {
    const qs = toQS(payload);
    const res = await apiClient(`/workflows/api/v1/notifications/${qs}`, {
      method: 'GET',
    });
    return res as NotificationsListResponse;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load notifications';
    return rejectWithValue(String(msg));
  }
});
